import { useEffect } from 'react';
import { Result, Typography, Space, Spin } from 'antd';
import {
  CheckCircleFilled,
  MailOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { verifyCheckoutSession } from '../../store/actions/payments';
import { useAuth, useAuthActions } from '@frontegg/react';
import { getCurrentPractitionerEntitlements } from 'src/store/actions/practitioner.action';
import { analytics } from 'src/services';

const { Paragraph, Link, Title } = Typography;

export const StripeCheckoutSuccess = () => {
  const { session, sessionStatus, sessionVerifying } = useSelector(
    (state) => state?.paymentsState
  );
  const { currentPractitionerEntitlementsLoading } = useSelector(
    (state) => state?.practitionerState
  );

  const dispatch = useDispatch();
  const { loadEntitlements } = useAuthActions();
  const { user } = useAuth();

  useEffect(() => {
    if (session?.session_id) {
      dispatch(verifyCheckoutSession(session?.session_id));
      analytics.track('Verifying Payment Status In Upgrade To Pro', {
        email: user?.email,
      });
    }
  }, [dispatch, session, user?.email]);

  useEffect(() => {
    if (sessionStatus == 'success') {
      loadEntitlements();
      dispatch(getCurrentPractitionerEntitlements());

      analytics.track('Successfully Upgraded User in Upgrade To Pro', {
        email: user?.email,
      });
    }
  }, [dispatch, loadEntitlements, sessionStatus, user?.email]);

  if (sessionVerifying || currentPractitionerEntitlementsLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Result
          icon={
            <Spin
              indicator={
                <LoadingOutlined
                  style={{ fontSize: 24, color: '#0F9F67' }}
                  spin
                />
              }
            />
          }
          title={<Title level={2}>Verifying your payment</Title>}
          subTitle="Please wait while we confirm your transaction..."
        />
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Result
        icon={<CheckCircleFilled style={{ color: '#0F9F67' }} />}
        title={<Title level={2}>You have been upgraded!</Title>}
        subTitle={
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Paragraph>
              {`You have been upgraded! If you don't see the new features, please
              refresh the page.`}
            </Paragraph>
            <Paragraph>
              If you have any questions, please email{' '}
              <Link href="mailto:billing@insighthealth.ai">
                <MailOutlined /> billing@insighthealth.ai
              </Link>
              .
            </Paragraph>
          </Space>
        }
      />
    </div>
  );
};
